import { render, staticRenderFns } from "./SectionProducts.vue?vue&type=template&id=03a603ff&scoped=true&"
import script from "./SectionProducts.vue?vue&type=script&lang=js&"
export * from "./SectionProducts.vue?vue&type=script&lang=js&"
import style0 from "./SectionProducts.vue?vue&type=style&index=0&id=03a603ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a603ff",
  null
  
)

export default component.exports